import { collection, getDocs, query, where, orderBy } from "firebase/firestore";
import { db } from "../firebase";
import { COLLECTIONS } from "../../services/collections";

/**
 * CatalogService
 * Serviço para buscar itens do catálogo (Produtos e Serviços) do tenant.
 * Coleção: tenants/{idTenant}/catalog
 */
export const CatalogService = {
    /**
     * Lista itens do catálogo com filtros opcionais.
     * @param {string} idTenant - ID do tenant
     * @param {string} _idBranch - Reservado (não utilizado atualmente)
     * @param {Object} filters - Filtros: { type: 'product'|'service', isActive: boolean }
     * @returns {Promise<Array>} Lista de itens
     */
    listWithFilters: async (idTenant, _idBranch, filters = {}) => {
        if (!idTenant) throw new Error("ID do Tenant é obrigatório.");

        try {
            const constraints = [orderBy("name", "asc")];

            if (filters.type) {
                constraints.push(where("type", "==", filters.type));
            }
            if (filters.isActive !== undefined) {
                constraints.push(where("isActive", "==", filters.isActive));
            }

            const q = query(
                collection(db, "tenants", idTenant, COLLECTIONS.CATALOG),
                ...constraints
            );

            const snapshot = await getDocs(q);
            const items = [];
            snapshot.forEach((doc) => {
                items.push({ id: doc.id, ...doc.data() });
            });
            return items;
        } catch (error) {
            console.error("[CatalogService] Erro ao listar itens:", error);
            throw error;
        }
    }
};
